// Gym portfolio data. Source: Semrush US estimates, Oct 2026 (Before = launch month).
export const GYM_PORTFOLIO_FOOTNOTE = "Semrush US estimates, Oct 2026. Third-party estimates, not first-party analytics.";

export const GYM_PORTFOLIO_FILTERS = [
  { key: "all", label: "All" },
  { key: "health-clubs", label: "Gyms & Health Clubs" },
  { key: "crossfit-hyrox", label: "CrossFit / HYROX" },
  { key: "pilates-studios", label: "Pilates & Studios" },
  { key: "martial-arts", label: "Martial Arts" },
  { key: "fitness-brands", label: "Fitness Brands" },
];

export const GYM_PORTFOLIO = [
  {
    slug: "delta-valley-health-club",
    name: "Delta Valley Health Club",
    type: "Health club",
    city: "Brentwood, CA",
    url: "https://deltavalleyhealthclub.com",
    category: "health-clubs",
    beforeLabel: "May 2026 (launch)",
    tableBefore: "3 keywords, ~1 visit/mo",
    tableAfter: "650 keywords · ~3,440 visits/mo · 171 top-10 · 105 local-pack",
    metrics: [
      { m: "Ranking keywords", b: "3", a: "650" },
      { m: "Est. monthly organic visits", b: "~1", a: "~3,440" },
      { m: "Top-10 rankings", b: "—", a: "171" },
      { m: "Local-pack rankings", b: "—", a: "105" },
    ],
    headline: '#1 "delta valley health club" (1,300/mo) · #1 "cost of pilates classes" (390/mo)',
  },
  {
    slug: "boston-iron-grit",
    name: "CrossFit Boston Iron & Grit",
    type: "CrossFit box",
    city: "West Roxbury, MA",
    url: "https://bostonirongrittraining.com",
    category: "crossfit-hyrox",
    beforeLabel: "Jul 2026 (launch)",
    tableBefore: "0 keywords",
    tableAfter: "83 keywords · ~829 visits/mo · 7 top-3",
    metrics: [
      { m: "Ranking keywords", b: "0", a: "83" },
      { m: "Est. monthly organic visits", b: "0", a: "~829" },
      { m: "Top-3 rankings", b: "—", a: "7" },
    ],
    headline: '#1 "crossfit west roxbury"',
  },
  {
    slug: "dallas-performance-systems",
    name: "Dallas Performance Systems",
    type: "HYROX training club",
    city: "Dallas, TX",
    url: "https://dallasperformancesystems.com",
    category: "crossfit-hyrox",
    beforeLabel: "Apr 2026 (launch)",
    tableBefore: "4 keywords, ~23 visits/mo",
    tableAfter: "176 keywords · ~519 visits/mo · 22 local-pack",
    metrics: [
      { m: "Ranking keywords", b: "4", a: "176" },
      { m: "Est. monthly organic visits", b: "~23", a: "~519" },
      { m: "Local-pack rankings", b: "—", a: "22" },
    ],
    headline: '#1 "dallas performance systems" · #23 "hyrox dallas" (12,100/mo)',
  },
  {
    slug: "pitfit",
    name: "PitFit",
    type: "HIIT studio",
    city: "Dallas, TX (launched Sept 2026)",
    url: "https://pitfitworkout.com",
    category: "pilates-studios",
    beforeLabel: "Aug 2026",
    tableBefore: "141 keywords, ~419 visits/mo, 14 top-10",
    tableAfter: "143 keywords · ~506 visits/mo · 24 top-10 (+71%)",
    metrics: [
      { m: "Ranking keywords", b: "141", a: "143" },
      { m: "Est. monthly organic visits", b: "~419", a: "~506" },
      { m: "Top-10 rankings", b: "14", a: "24 (+71%)" },
    ],
    headline: '#1 "pitfit dallas" · #5 "hiit fitness studio"',
  },
  {
    slug: "ninjathlete",
    name: "NinjAthlete",
    type: "Fitness media brand",
    city: "Online",
    url: "https://ninjathlete.com",
    category: "fitness-brands",
    beforeLabel: "Mar 2026 (rebuild)",
    tableBefore: "2,526 keywords, ~232 visits/mo, 49 top-10",
    tableAfter: "3,332 keywords · ~1,273 visits/mo · 321 top-10",
    metrics: [
      { m: "Ranking keywords", b: "2,526", a: "3,332" },
      { m: "Est. monthly organic visits", b: "~232", a: "~1,273" },
      { m: "Top-10 rankings", b: "49", a: "321" },
    ],
    headline: "Traffic 5.5x since rebuild",
    note: "Rebuilt on Emergent, March 2026",
  },
  {
    slug: "dfwfitmeals",
    name: "DFW Fit Meals",
    type: "Fitness meal prep",
    city: "Dallas–Fort Worth, TX",
    url: "https://dfwfitmeals.com",
    category: "fitness-brands",
    beforeLabel: "Mar 2026",
    tableBefore: "4 keywords",
    tableAfter: "133 keywords · 72 local-pack",
    metrics: [
      { m: "Ranking keywords", b: "4", a: "133" },
      { m: "Local-pack rankings", b: "—", a: "72" },
    ],
    headline: "Local pack across DFW",
  },
  {
    slug: "reyna-pilates",
    name: "Reyna Pilates",
    type: "Pilates studio",
    city: "Odessa, TX (pre-opening)",
    url: "https://reynapilates.com",
    category: "pilates-studios",
    beforeLabel: "Jul 2026 (launch)",
    tableBefore: "0 keywords",
    tableAfter: "44 keywords · ~35 visits/mo · 34 local-pack",
    metrics: [
      { m: "Ranking keywords", b: "0", a: "44" },
      { m: "Est. monthly organic visits", b: "0", a: "~35" },
      { m: "Local-pack rankings", b: "—", a: "34" },
    ],
    headline: '#3 "pilates odessa tx" before opening',
  },
  {
    slug: "hidden-gym",
    name: "Hidden Gym",
    type: "Gym",
    city: "Richardson / North Dallas, TX",
    url: "https://dallashiddengym.com",
    category: "health-clubs",
    beforeLabel: "Aug 2026 (launch)",
    tableBefore: "0 keywords",
    tableAfter: "36 keywords · 15 local-pack",
    metrics: [
      { m: "Ranking keywords", b: "0", a: "36" },
      { m: "Local-pack rankings", b: "—", a: "15" },
    ],
    headline: '#13 "hidden gym allen"',
  },
  {
    slug: "mma-dallas",
    name: "MMA Dallas (Guy Mezger)",
    type: "MMA",
    city: "Dallas, TX",
    url: "https://mmadallas.com",
    category: "martial-arts",
    recentlyLaunched: true,
  },
  {
    slug: "hyroxninja",
    name: "HyroxNinja",
    type: "HYROX booking site",
    city: "Online",
    url: "https://hyroxninja.com",
    category: "crossfit-hyrox",
    recentlyLaunched: true,
  },
];
